/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ApiAuthenticationService } from './services/api-authentication.service';
import { ApiBookingsService } from './services/api-bookings.service';
import { ApiChatsService } from './services/api-chats.service';
import { ApiDocumentsService } from './services/api-documents.service';
import { ApiFaqService } from './services/api-faq.service';
import { ApiLoyaltyService } from './services/api-loyalty.service';
import { ApiNotificationsService } from './services/api-notifications.service';
import { ApiOrdersService } from './services/api-orders.service';
import { ApiPaymentsService } from './services/api-payments.service';
import { ApiRegistrationService } from './services/api-registration.service';
import { ApiRestaurantsService } from './services/api-restaurants.service';
import { ApiSurveysService } from './services/api-surveys.service';
import { ApiTestsService } from './services/api-tests.service';
import { ApiTicketsService } from './services/api-tickets.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ApiAuthenticationService,
    ApiBookingsService,
    ApiChatsService,
    ApiDocumentsService,
    ApiFaqService,
    ApiLoyaltyService,
    ApiNotificationsService,
    ApiOrdersService,
    ApiPaymentsService,
    ApiRegistrationService,
    ApiRestaurantsService,
    ApiSurveysService,
    ApiTestsService,
    ApiTicketsService,
    ApiConfiguration,
  ],
})
export class ApiClientModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiClientModule> {
    return {
      ngModule: ApiClientModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiClientModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiClientModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' + 'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
